import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRecurringScheduleTable extends Layout {
    sourceRecurringSched: DataSource;
    tableRecurringSchedule: Table;
}
